/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} This_Season_PeriodInputs */

const en_this_season_period = /** @type {(inputs: This_Season_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This Season’s Content & Duration  
**10/1/2025 – 12/31/2025** (GMT+0)`)
};

const ar_this_season_period = /** @type {(inputs: This_Season_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`محتوى هذا الموسم ومدته  
**1/10/2025 – 31/12/2025** (GMT+0)`)
};

const de_this_season_period = /** @type {(inputs: This_Season_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inhalt und Dauer dieser Saison  
**1/10/2025 – 31/12/2025** (GMT+0)`)
};

const es_this_season_period = /** @type {(inputs: This_Season_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenido y duración de esta temporada  
**01/10/2025 - 31/12/2025** (GMT+0)`)
};

const fr_this_season_period = /** @type {(inputs: This_Season_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenu de cette saison et durée  
**01/10/2025 – 31/12/2025** (GMT+0)`)
};

const it_this_season_period = /** @type {(inputs: This_Season_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenuti e durata di questa stagione  
**1/10/2025 – 31/12/2025** (GMT+0)`)
};

const ja_this_season_period = /** @type {(inputs: This_Season_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今シーズンのコンテンツ＆期間  
**2025年10月1日～2025年12月31日** (GMT+0)`)
};

const ko_this_season_period = /** @type {(inputs: This_Season_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이번 시즌 콘텐츠 및 기간  
**2025/10/1 - 2025/12/31** (GMT+0)`)
};

const pt_br_this_season_period = /** @type {(inputs: This_Season_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conteúdo e duração desta temporada  
**01/10/2025 – 31/12/2025** (GMT+0)`)
};

const ru_this_season_period = /** @type {(inputs: This_Season_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контент и продолжительность этого сезона  
**1/10/2025 г. — 31/12/2025 г.** (GMT+0)`)
};

const th_this_season_period = /** @type {(inputs: This_Season_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เนื้อหาและระยะเวลาของฤดูกาลนี้  
**01/10/2025 – 31/12/2025** (GMT+0)`)
};

const tr_this_season_period = /** @type {(inputs: This_Season_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu Mevsimin İçeriği ve Süresi  
**01/10/2025 - 31/12/2025** (GMT+0)`)
};

const zh_cn_this_season_period = /** @type {(inputs: This_Season_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本季内容与期间：  
**2025/10/1 ～ 2025/12/31** (GMT+0)`)
};

const zh_tw_this_season_period = /** @type {(inputs: This_Season_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本季內容與期間：  
**2025/10/1 ～ 2025/12/31** (GMT+0)`)
};

/**
* | output |
* | --- |
* | "This Season’s Content & Duration **10/1/2025 – 12/31/2025** (GMT+0)" |
*
* @param {This_Season_PeriodInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const this_season_period = /** @type {((inputs?: This_Season_PeriodInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<This_Season_PeriodInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_this_season_period(inputs)
	if (locale === "ar") return ar_this_season_period(inputs)
	if (locale === "de") return de_this_season_period(inputs)
	if (locale === "es") return es_this_season_period(inputs)
	if (locale === "fr") return fr_this_season_period(inputs)
	if (locale === "it") return it_this_season_period(inputs)
	if (locale === "ja") return ja_this_season_period(inputs)
	if (locale === "ko") return ko_this_season_period(inputs)
	if (locale === "pt_br") return pt_br_this_season_period(inputs)
	if (locale === "ru") return ru_this_season_period(inputs)
	if (locale === "th") return th_this_season_period(inputs)
	if (locale === "tr") return tr_this_season_period(inputs)
	if (locale === "zh_cn") return zh_cn_this_season_period(inputs)
	return zh_tw_this_season_period(inputs)
});